﻿// This file creates <meta> tags for Webtrends analytics for the current page, adding them to the <head>
// Store tags for a site in an array to add later
var metaTags = [];
var pgUrl = document.URL.toLowerCase();
// these tags are always set, even if empty content, to preserve prior logic, including blank values for
// these three values.  Add other tags using this syntax:  addTag("WT.cg_n", "Tools;Locators");
var metaCgN = document.createElement("meta");
var metaCgS = document.createElement("meta");
var metaPi = document.createElement("meta");
metaCgN.name = "WT.cg_n";
metaCgS.name = "WT.cg_s";
metaPi.name = "Wt.pi";

function createMetaTag(name, content) {
    var tag = document.createElement("meta");
    tag.name = name;
    tag.content = content;
    return tag;
}

function addTag(name, content) {
    metaTags.push(createMetaTag(name, content));
}

if (window.location.href.indexOf('?display=map') > -1) {
    bol_GOT_HERE_FROM_WIDGET = true;
    pgUrl = pgUrl.replace('?display=map', '`').split('`')[0];
}

if (window.location.href.indexOf('?display=map') == -1) {
    bol_GOT_HERE_FROM_WIDGET = false;
}

// Create meta tags based on which page is accessed, using the URL
if (pgUrl.indexOf("hdslocator") > -1) {
    metaCgN.content = "Tools;Locators";
    metaCgS.content = "Locators;Find a Migrant and Seasonal Head Start Center (MSHS)";
    metaPi.content = "Find a MSHS";
    addTag("WT.si_n", "Find MSHS");
    addTag("WT.si_p", "Enter Location");
}

if (pgUrl.indexOf("findanetwork") > -1) {
    metaCgN.content = "Tools;Locators";
    metaCgS.content = "Locators;Find a Health Center Controlled Network - Production";
    metaPi.content = "Find a Health Center Controlled Network";
    addTag("WT.si_n", "Find a Network");
    addTag("WT.si_p","Enter Location");
    if(pgUrl.indexOf("tool")>-1) {
        document.title="About Find a Health Center Controlled Network";
        document.getElementsByTagName('meta')["description"].content="Details on about using the Find a Health Center Controlled Network tool.";
        document.getElementsByTagName('meta')["keywords"].content="About, HCCN, HCCNs, Tool, Locate, Mapping";
    }
}

if (pgUrl.indexOf("opotxfind") > -1) {
    metaCgN.content = "Tools;Locators";
    metaCgS.content = "Locators;Find Organ Procurement Organizations(OPOs) / Organ Transplant Programs - Production";
    metaPi.content = "Find OPOs/Organ Transplant Programs";
    addTag("WT.si_n", "Find OPOs");
    addTag("WT.si_p","Enter Location");
    if(pgUrl.indexOf("program")>-1) {
        document.title="About Find an Organ Transplant Center";
        document.getElementsByTagName('meta')["description"].content="Learn about Organ Transplantation System and organ donation and registration";
        document.getElementsByTagName('meta')["keywords"].content="Organ, Organ Procurement, Organ Transplantation, OPTN, SRTR, locate, mapping, Policies";
    }
}

if (pgUrl.indexOf("findahealthcenter") > -1) {
    metaCgN.content = "Tools;Locators";
    metaCgS.content = "Locators;Find a Health Center";
    metaPi.content="Find a Health Center";
    if (pgUrl.indexOf("note") > -1)
    {
        document.title="Note To HRSA Health Centers";
        document.getElementsByTagName('meta')["description"].content="HRSA Note to Health Center Grantees and Look-Alikes";
        document.getElementsByTagName('meta')["keywords"].content="Health Centers, Grantees,Look-Alikes, EHBs, Grant, Handbook";
    }
    if(pgUrl.indexOf("tool") > -1) {
        document.title="Find a Health Center Tool";
        document.getElementsByTagName('meta')["description"].content="Instructions using the Find a Health Center Tool";
        document.getElementsByTagName('meta')["keywords"].content="find, health center, tool, geoloction";
    }
}

if (pgUrl.indexOf("findhivcare") > -1) {
    metaCgN.content = "Tools;Locators";
    metaCgS.content = "Locators;Find a Ryan White HIV/AIDS Program Medical Provider";
    metaPi.content = "Find a Ryan White HIV/AIDS Program Medical Provider";
    addTag("WT.si_n", "Find HIV/AIDS");
    addTag("WT.si_p","Enter Location");
    if(pgUrl.indexOf("tool")>-1) {
        document.title="About Find a Ryan White HIV/AIDS Program Medical Provider";
        document.getElementsByTagName('meta')["description"].content="Details on about using the Find a Ryan White HIV/AIDS Program Medical Provider tool.";
        document.getElementsByTagName('meta')["keywords"].content="about, information, Ryan White, HIV, AIDS, HIV/AIDS, geolocation, RSR, RWHAP, Funded";
    }
}

// add any other meta tags to the head of the page
var head = document.getElementsByTagName("head")[0];
head.appendChild(metaCgN);
head.appendChild(metaCgS);
head.appendChild(metaPi);
for (var i in metaTags) {
    if (metaTags.hasOwnProperty(i)) {
        head.appendChild(metaTags[i]);
    }
}


